import { useRef, useState } from "react";
import styles from "./Step.module.scss";
import { validateEmail } from "@/utils/regex";

export const StepFour = ({
  handleInputChange,
  errorFormData,
  formData,
  setErrorFormData,
  messages,
}) => {
  const [isFileUploaded, setIsFileUploaded] = useState();
  const fileInputRef = useRef(null);

  const handleInputChanges = (name, value, file = null) => {
    if (name === "cv" && file) {
      const fileName = file.name;
      const fileExtension = fileName.split(".").pop().toLowerCase();

      const allowedExtensions = [
        "pdf",
        "doc",
        "docx",
        "odt",
        "rtf",
        "txt",
        "pptx",
        "svg",
        "jpg",
        "jpeg",
        "png",
        "rar",
        "zip",
      ];

      if (allowedExtensions.includes(fileExtension)) {
        setIsFileUploaded(fileName);
        setErrorFormData((prevErrors) => ({ ...prevErrors, [name]: "" }));

        handleInputChange(name, file);
        formData.cv = file;
        return;
      } else {
        setErrorFormData((prevErrors) => ({
          ...prevErrors,
          [name]: "Tipo de archivo no permitido",
        }));
        return;
      }
    }

    handleInputChange(name, value);
    setErrorFormData((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  return (
    <div className={styles.dialogText}>
      <h2>{messages.title}</h2>
      <form className={styles.formInputContainer}>
        <div className={`${styles.fieldContainer} ${styles.nameContainer}`}>
          <div className={styles.inputContainer}>
            <input
              type="text"
              name="applicantName"
              value={formData.applicantName}
              onChange={(e) => handleInputChanges("applicantName", e.target.value)}
              className={`
                ${formData.applicantName ? styles.noEmpty : ""}
                ${errorFormData?.applicantName ? styles.borderError : ""}
              `}
            />
            <label
              htmlFor="applicantName"
              className={errorFormData.applicantName ? styles.errorLabel : ""}
            >
              {messages.applicantName || "Nombre completo"}
            </label>
            {errorFormData?.applicantName ? (
              <span className={styles.errorMessage}>
                {errorFormData.applicantName}
              </span>
            ) : null}
          </div>
        </div>

        <div className={`${styles.fieldContainer} ${styles.emailContainer}`}>
          <div className={styles.inputContainer}>
            <input
              type="email"
              name="applicantEmail"
              value={formData.applicantEmail}
              onChange={(e) => {
                const value = e.target.value;
                handleInputChanges("applicantEmail", value);
                if (value && !validateEmail(value)) {
                  setErrorFormData((prevErrors) => ({
                    ...prevErrors,
                    applicantEmail: messages.emailError || "Email inválido",
                  }));
                }
              }}
              className={`
                ${formData.applicantEmail ? styles.noEmpty : ""}
                ${errorFormData?.applicantEmail ? styles.borderError : ""}
              `}
            />
            <label
              htmlFor="applicantEmail"
              className={errorFormData.applicantEmail ? styles.errorLabel : ""}
            >
              {messages.email || "Email"}
            </label>
            {errorFormData?.applicantEmail ? (
              <span className={styles.errorMessage}>
                {errorFormData.applicantEmail}
              </span>
            ) : null}
          </div>
        </div>

        <div className={styles.areaContainer}>
          <textarea
            name="description"
            value={formData.description}
            onChange={(e) => handleInputChanges("description", e.target.value)}
            className={`
            ${formData.description ? styles.noEmpty : ""}
            ${errorFormData?.description ? styles.borderError : ""}
            `}
          />
          <label htmlFor="description">{messages.description}</label>
          {errorFormData?.description ? (
            <span>{errorFormData.description}</span>
          ) : null}
        </div>

        <div className={styles.fieldContainer}>
          <div className={styles.inputContainer}>
            <span
              className={`${styles.currency}   ${formData.expected_income ? styles.noEmpty : ""}`}
            >
              $
            </span>
            <input
              type="text"
              name="expected_income"
              value={formData.expected_income}
              onChange={(e) => {
                const value = e.target.value;
                const isNumeric = /^[0-9]*$/.test(value);
                if (isNumeric || value === "") {
                  handleInputChange("expected_income", value);
                  setErrorFormData((prevErrors) => ({
                    ...prevErrors,
                    expected_income: "",
                  }));
                }
              }}
              className={`
            ${formData.expected_income ? styles.noEmpty : ""}
            ${errorFormData?.expected_income ? styles.borderError : ""}
            `}
            />
            <label
              htmlFor="expected_income"
              className={errorFormData.expected_income ? styles.errorLabel : ""}
            >
              {messages.expected_income}
            </label>
            {errorFormData?.expected_income ? (
              <span className={styles.errorMessage}>
                {errorFormData.expected_income}
              </span>
            ) : null}
          </div>
        </div>
        <div
          className={`${styles.fieldContainer} ${styles.fileContainer} ${isFileUploaded ? styles.isFile : ""}`}
        >
          <div className={styles.inputContainer}>
            <input
              type="file"
              accept=".pdf,.doc,.docx,.odt,.rtf,.txt,.pptx,.svg,.jpg,.jpeg,.png,.rar,.zip"
              name="cv"
              // value={formData.cv}
              onChange={(e) => {
                handleInputChanges("cv", e.target.value, e.target.files[0]);
              }}
              className={`${formData.cv ? styles.noEmpty : ""} ${
                errorFormData.cv ? styles.borderError : ""
              }`}
              ref={fileInputRef}
            />

            <label htmlFor="cv">{messages.cv}</label>
            {isFileUploaded ? (
              <div
                className={styles.iconContainer}
                onClick={() => {
                  setIsFileUploaded(null);
                  handleInputChanges("cv", "");
                }}
              >
                <svg
                  width="17"
                  height="18"
                  viewBox="0 0 17 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.025 18C2.625 18 2.275 17.85 1.975 17.55C1.675 17.25 1.525 16.9 1.525 16.5V2.25H1.25C1.0375 2.25 0.859375 2.17771 0.715625 2.03313C0.571875 1.88853 0.5 1.70936 0.5 1.49563C0.5 1.28188 0.571875 1.10417 0.715625 0.9625C0.859375 0.820833 1.0375 0.75 1.25 0.75H5.2C5.2 0.533333 5.27187 0.354167 5.41563 0.2125C5.55938 0.0708333 5.7375 0 5.95 0H11.05C11.2625 0 11.4406 0.071875 11.5844 0.215625C11.7281 0.359375 11.8 0.5375 11.8 0.75H15.75C15.9625 0.75 16.1406 0.822292 16.2844 0.966875C16.4281 1.11148 16.5 1.29064 16.5 1.50437C16.5 1.71812 16.4281 1.89583 16.2844 2.0375C16.1406 2.17917 15.9625 2.25 15.75 2.25H15.475V16.5C15.475 16.9 15.325 17.25 15.025 17.55C14.725 17.85 14.375 18 13.975 18H3.025ZM3.025 2.25V16.5H13.975V2.25H3.025ZM5.675 13.6C5.675 13.8125 5.74729 13.9906 5.89187 14.1344C6.03647 14.2781 6.21564 14.35 6.42937 14.35C6.64312 14.35 6.82083 14.2781 6.9625 14.1344C7.10417 13.9906 7.175 13.8125 7.175 13.6V5.125C7.175 4.9125 7.10271 4.73438 6.95813 4.59063C6.81353 4.44688 6.63436 4.375 6.42063 4.375C6.20688 4.375 6.02917 4.44688 5.8875 4.59063C5.74583 4.73438 5.675 4.9125 5.675 5.125V13.6ZM9.825 13.6C9.825 13.8125 9.89729 13.9906 10.0419 14.1344C10.1865 14.2781 10.3656 14.35 10.5794 14.35C10.7931 14.35 10.9708 14.2781 11.1125 14.1344C11.2542 13.9906 11.325 13.8125 11.325 13.6V5.125C11.325 4.9125 11.2527 4.73438 11.1081 4.59063C10.9635 4.44688 10.7844 4.375 10.5706 4.375C10.3569 4.375 10.1792 4.44688 10.0375 4.59063C9.89583 4.73438 9.825 4.9125 9.825 5.125V13.6Z"
                    fill="#AF2EFF"
                  />
                </svg>
              </div>
            ) : (
              <div
                className={styles.iconContainer}
                onClick={() => fileInputRef.current.click()}
              >
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.46157 10.0384H1.53847C1.24423 10.0384 0.997598 9.93888 0.798559 9.73977C0.59952 9.54064 0.5 9.2939 0.5 8.99955C0.5 8.70518 0.59952 8.45859 0.798559 8.25978C0.997598 8.06097 1.24423 7.96157 1.53847 7.96157H8.46157V1.03847C8.46157 0.744234 8.56112 0.497598 8.76023 0.298559C8.95936 0.0995196 9.2061 0 9.50045 0C9.79482 0 10.0414 0.0995196 10.2402 0.298559C10.439 0.497598 10.5384 0.744234 10.5384 1.03847V7.96157H17.4615C17.7558 7.96157 18.0024 8.06112 18.2014 8.26023C18.4005 8.45936 18.5 8.7061 18.5 9.00045C18.5 9.29482 18.4005 9.54141 18.2014 9.74022C18.0024 9.93903 17.7558 10.0384 17.4615 10.0384H10.5384V16.9615C10.5384 17.2558 10.4389 17.5024 10.2398 17.7014C10.0406 17.9005 9.7939 18 9.49955 18C9.20518 18 8.95859 17.9005 8.75978 17.7014C8.56097 17.5024 8.46157 17.2558 8.46157 16.9615V10.0384Z"
                    fill="#AF2EFF"
                  />
                </svg>
              </div>
            )}
            <span className={styles.fileName}>
              {isFileUploaded ? isFileUploaded : ""}
            </span>
          </div>
          {errorFormData?.cv ? (
            <span className={styles.errorCVLabel}>{errorFormData.cv}</span>
          ) : null}
        </div>
      </form>
    </div>
  );
};
